import type { InternalNetworkAttackPathEventDto } from '@terra/shared-contracts-internal-network';
import { collapseAttackPathRetryEvents } from './collapse-attack-path-retry-events.util';
import { dropAttackPathFailedHopYields } from './drop-attack-path-failed-hop-yields.util';
import { dropAttackPathNonMilestoneImpacts } from './drop-attack-path-non-milestone-impacts.util';
import { dropAttackPathPlaceholderCredentials } from './drop-attack-path-placeholder-credentials.util';

export const sanitizeAttackPathEvents = (
  events: InternalNetworkAttackPathEventDto[],
): InternalNetworkAttackPathEventDto[] =>
  dropAttackPathNonMilestoneImpacts(
    dropAttackPathPlaceholderCredentials(
      dropAttackPathFailedHopYields(collapseAttackPathRetryEvents(events)),
    ),
  );
